import React from 'react';

export default function Col({ classes, children }) {
  return <div className={classes || 'col-sm'}>{children}</div>;
}
